import { useAppContext, useAppStaticContext } from './AppContext';
import { Button } from './Button';
import { ReferralBoxContentSection } from './contentTypes';
import { t } from './i18n/i18n';
import { ReferralBoxUI } from './ReferralBoxUI';
import { useSharingModal } from './SharingModal';
import { useReferralCode } from './useReferralCode';
import { useShareButtonClickHandler } from './useShareButtonClickHandler';
import { formatHtml } from './util';

interface ReferralBoxProps extends ReferralBoxContentSection {
  sharingOptions?: {
    alternativeText?: string;
    disableSharing?: boolean;
    friendType?: string;
    pageCode?: string;
  };
  slidesPerViewLg?: number;
}

const ReferralBoxShareButton = ({
  shareCta,
  shareDataTitle,
  sharingOptions,
}: Pick<ReferralBoxProps, 'shareCta' | 'shareDataTitle' | 'sharingOptions'>) => {
  const [SharingModal, showSharingModal] = useSharingModal();

  const { referralLink } = useReferralCode(sharingOptions?.friendType, sharingOptions?.pageCode);

  const handleShareButtonClick = useShareButtonClickHandler({
    data: {
      title: shareDataTitle,
      url: referralLink,
    },
    fallback: showSharingModal,
  });

  return (
    <>
      <Button
        iconStart={{ name: shareCta?.icon || '', size: 24 }}
        label={shareCta?.label}
        onClick={handleShareButtonClick}
        variant={shareCta?.variant}
      />
      {SharingModal}
    </>
  );
};

export const ReferralBox = ({ shareCta, shareDataTitle, sharingOptions, ...props }: ReferralBoxProps) => {
  const { session } = useAppContext();
  const isLoggedIn = !!session?.customer;

  const { onLoginActionCallback } = useAppStaticContext();

  return (
    <>
      <ReferralBoxUI {...props}>
        {isLoggedIn ? (
          sharingOptions?.disableSharing !== true ? (
            <ReferralBoxShareButton
              shareCta={shareCta}
              shareDataTitle={shareDataTitle}
              sharingOptions={sharingOptions}
            />
          ) : (
            formatHtml(sharingOptions.alternativeText)
          )
        ) : (
          <Button onClick={onLoginActionCallback}>{t('misc.loginRegister')}</Button>
        )}
      </ReferralBoxUI>
    </>
  );
};
